import * as t from 'io-ts';

import {makeApiType} from './apiTypes';

/*
 * Runtime type.
 */

const REmailCountPayload = t.readonly(
  t.type({
    count: t.Integer,
  }),
);

/*
 * Type.
 */

export interface EmailCountModel extends t.TypeOf<typeof REmailCountPayload> {}
export const ApiEmailCount = makeApiType('emailCount', REmailCountPayload, (src) => src);
